// extracted by mini-css-extract-plugin
module.exports = {"noWrap":"yQhxJ","ctaLink":"_2-a0C"};